import { render } from "./TiptapUi.vue?vue&type=template&id=3f952463"
import script from "./TiptapUi.vue?vue&type=script&lang=js"
export * from "./TiptapUi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__